import { useRef, useState } from 'react';
import classNames from 'classnames';

import { BASE_URL } from '@/services/Constants';

import { FormDropdownProps } from '@/components/dropdown/types';
import Skeleton from '@/components/Skeleton';

const FormDropdown = ({
	dataNameAttribute,
	dataPrivate = true,
	expanded = false,
	floatingLabel = false,
	headerAva,
	headerAvaOutside,
	headerFlag,
	headerIcon,
	hideExpandedIcon,
	label,
	loading,
	optionFlagProperty,
	selectedSubValue,
	selectedValue,
	showHeaderAva,
	showHeaderIcon = true,
	showPlaceholderIcon,
	toggleDropdown,
	valuePrefix,
}: FormDropdownProps) => {
	const [mouseDown, setMouseDown] = useState(false);
	const formRef = useRef<HTMLDivElement | null>(null);

	const onMouseDown = () => {
		setMouseDown(true);
	};

	const onMouseUp = () => {
		setMouseDown(false);
	};

	const onFocus = () => {
		if (!mouseDown) {
			toggleDropdown();
		}
	};

	return (
		<>
			{loading ? (
				<Skeleton className="form-skeleton" />
			) : (
				<div
					ref={formRef}
					className={classNames('dropdown-form', {
						'hide-label': !floatingLabel && !!selectedValue,
					})}
					data-name={dataNameAttribute}
					data-private={dataPrivate as any}
					onClick={toggleDropdown}
					onFocus={onFocus}
					onMouseUp={onMouseUp}
					onMouseDown={onMouseDown}
					tabIndex={0}
				>
					{showHeaderAva && headerAva && !headerIcon && !headerFlag && (
						<div className="avatar left-icon">
							<img
								src={(headerAvaOutside ? '' : BASE_URL) + headerAva}
								alt="subjectLogo"
								width="24px"
								height="24px"
							/>
						</div>
					)}
					{showHeaderIcon && headerIcon && (
						<span className={classNames('icon', headerIcon, 'left-icon')} />
					)}
					{showHeaderIcon && (headerFlag || (!selectedValue && showPlaceholderIcon)) && (
						<span
							className={classNames(
								optionFlagProperty as string,
								`${optionFlagProperty}-${headerFlag}`,
								'left-icon',
								{ 'placeholder-icon': !selectedValue && showPlaceholderIcon },
							)}
						/>
					)}
					{valuePrefix && (
						<span className="title value-prefix hide-xs">{valuePrefix}</span>
					)}
					<span className="title">{selectedValue}</span>
					{selectedSubValue && (
						<span className="title sub-title">{selectedSubValue}</span>
					)}
					<span className={classNames('label', { active: !!selectedValue })}>
						{label}
					</span>
					<span
						className={classNames(
							'icon',
							{ 'icon-chevron-down': !hideExpandedIcon },
							'right-icon',
							{ expanded },
						)}
					/>
				</div>
			)}
		</>
	);
};

export default FormDropdown;
